import { useStudioTeam } from '@/api/studio';
import { QueryPending } from '@/components/QueryState';
import { Empty, PageHeader } from '@/components/ui';
import { studioCan } from '@/lib/access';
import { AuditLog } from './AuditLog';
import { AdminTabs } from './StudioAdmin';

/** Администрирование → Журнал действий. Owners only, like the team page (the server answers 403 to anyone else). */
export function StudioAudit() {
  const team = useStudioTeam();
  const me = team.data?.[0];
  if (!me) return <QueryPending query={team} />;
  if (!studioCan(me.studioRole, 'team')) return <Empty title="Раздел для владельцев студии">Журнал действий смотрит владелец студии.</Empty>;
  return (
    <>
      <PageHeader title="Журнал действий" description="Кто, когда и что сделал в кабинете: входы, доступы, деньги, проекты. Отбор записывается в адрес страницы, им можно поделиться." />
      <AdminTabs />
      <AuditLog />
    </>
  );
}
